import {
  create_card_project,
  update_card_project,
  delete_card_project,
  recover_card_project,
  query_card_project_list,
} from '@/api/mjstore-model';
import { TableColumn } from '@/typing';
import { SearchConfig, Record } from '@/components/page-model/typing';
import ls from '@/utils/local-storage';
import { STORAGE_CURRENT_ORG_KEY } from '@/store/mutation-type';
import {
  slotList,
  btn_list,
  head_btn_list,
  event_obj,
  config,
} from '@/components/page-model/mjstore/mjstore-cardproject-config';

import { reactive } from 'vue';
import { get_is_active, getDateTime } from '@/utils/function';

const None = null;
const True = true;
const False = false;

const current_org = ls.get(STORAGE_CURRENT_ORG_KEY); // 当前组织org

const search_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'inline',
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'card_id',
      label: '卡',
      disabled: false,
      placeholder: '请选择卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-card',
    },
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目',
      disabled: false,
      placeholder: '请选择项目',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    card_id: null,
    project_id: null,
  }),
};
const search_options = {
  is_active: [
    { value: None, name: '全部' },
    { value: True, name: '可用' },
    { value: False, name: '作废' },
  ],
};

const edit_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'card_id',
      label: '卡',
      disabled: false,
      placeholder: '请选择卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-card',
    },
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目',
      disabled: false,
      placeholder: '请选择项目',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
  ],
  rules: {
    card_id: [{ required: true, message: '请填输入卡' }],
    project_id: [{ required: true, message: '请填输入项目' }],
  },
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    card_id: null,
    project_id: null,
  }),
};
const edit_model_config_options = {};

const update_model_config: SearchConfig = {
  settings: {
    labelAlign: 'right',
    layout: 'horizontal',
    col: config.creatCol,
  },
  fields: [
    {
      type: 'remotemodal',
      name: 'card_id',
      label: '卡',
      disabled: false,
      placeholder: '请选择卡',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-card',
    },
    {
      type: 'remotemodal',
      name: 'project_id',
      label: '项目',
      disabled: false,
      placeholder: '请选择项目',
      datasourceType: 'remote',
      mode: 'default',
      allowClear: true,
      modalType: 'mjstore-project',
    },
  ],
  rules: {},
  model: reactive({
    org_id: current_org?.id,
    is_active: true,
    card_id: null,
    project_id: null,
  }),
};
const update_model_config_options = {};

const titleList = {
  title: '卡的项目范围管理',
  addModalTitle: '新建卡的项目范围',
  updateTitle: '修改卡的项目范围',
  is_create: true, // 是否有【新建】按钮
  is_update: true, // 是否有【修改】按钮
  is_remove: true, // 是否有【删除】按钮
  is_recover: true, // 是否有【恢复】按钮
};

const api_fields: Record = {
  update: {
    cardproject_id: 'id',
  },
  delete: {
    cardproject_id: 'id',
  },
  recover: {
    cardproject_id: 'id',
  },
  updateData: {
    org_id: 'org_id',
    cardproject_id: 'id',
  },
};

const baseColumns: TableColumn[] = [
  {
    title: '序号',
    dataIndex: 'index',
    width: 50,
    fixed: 'left',
  },
  {
    title: '卡名称',
    width: 150,
    dataIndex: 'card__name',
    fixed: 'left',
    checked: true,
  },
  {
    title: '项目ID',
    width: 150,
    dataIndex: 'id',
    checked: false,
  },
  {
    title: '卡ID',
    width: 150,
    dataIndex: 'card_id',
    checked: false,
  },
  {
    title: '项目ID',
    width: 150,
    dataIndex: 'project_id',
    checked: false,
  },
  {
    title: '项目名称',
    width: 150,
    dataIndex: 'project__name',
    checked: true,
  },
  {
    title: '创建日期',
    width: 150,
    dataIndex: 'create_time',
    checked: true,

    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '更新时间',
    width: 150,
    dataIndex: 'update_time',
    checked: true,

    content: (record: any, text: any) => {
      return getDateTime(text);
    },
  },
  {
    title: '是否可用',
    width: 150,
    dataIndex: 'is_active',
    checked: true,

    cellComponent: 'boolean',
    name1: '可用',
    name2: '禁用',
    filterMultiple: false,
    filters: [
      { text: '全部', value: '' },
      { text: '可用', value: true },
      { text: '作废', value: false },
    ],
    content: (record: any, text: any) => {
      return get_is_active(text);
    },
  },

  {
    title: '操作',
    width: 200,
    dataIndex: 'action',
    checked: true,
    cellComponent: 'action',
    fixed: 'right',
  },
];
const newSlotList: any = [];
Object.assign(newSlotList, slotList);
newSlotList.push({
  type: 'custom',
  // slotName: 'is_active',
  field_true: '可用',
  field_false: '作废',
});

export default () => {
  return {
    searchConfig: search_config,
    searchConfigOptions: search_options,
    formModalConfig: edit_model_config,
    formModalConfigOptions: edit_model_config_options,
    updateFormModalConfig: update_model_config,
    updateFormModalConfigOptions: update_model_config_options,
    queryData: query_card_project_list,
    addData: create_card_project,
    updateData: update_card_project,
    removeData: delete_card_project,
    recoverData: recover_card_project,
    baseColumns: baseColumns,
    slotList: newSlotList,
    titleList: titleList,
    api_fields: api_fields,
    btn_list: btn_list,
    head_btn_list: head_btn_list,
    event_obj: event_obj,
  };
};
